import React from "react";

import CompetenceTab from "../../components/Shared/CompetenceTab/CompetenceTab";
import Consultant from "../../models/Consultant";
import { useUpdateCandidate } from "../../networking/candidate.hooks";
import ConsultantCredentialsPanel from "../Consultants/ConsultantCredentialsPanel";
import RecruitmentDocumentCheckList from "./RecruitmentDocumentCheckList";

const RecruitmentCompetenceTab: React.FC<{ candidate: Consultant }> = ({ candidate }) => {
	const { mutate: updateCandidate } = useUpdateCandidate();

	const handleUpdateUser = async (user: any, updateRequest: object) => {
		if (candidate?.id) {
			updateCandidate({ userId: user.id, update: updateRequest });
		}
	};

	if (!candidate) return null;

	return (
		<div className="max-w-[1400px] py-6 pr-4">
			<div className="grid grid-cols-1 items-start gap-6 xl:grid-cols-5">
				<div className="xl:col-span-3">
					<CompetenceTab user={candidate} onUpdateUser={handleUpdateUser} />
					<RecruitmentDocumentCheckList candidate={candidate} />
				</div>
				<div className="xl:col-span-2">
					<ConsultantCredentialsPanel consultant={candidate} isCandidate />
				</div>
			</div>
		</div>
	);
};

export default RecruitmentCompetenceTab;
